var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8200_130128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H6V5H0V3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 3C-1.5 0.680404 0.380404 -1.2 2.7 -1.2H7.5L4.5 1.2H3C2.17157 1.2 1.5 2.00589 1.5 3L-1.5 3ZM7.5 6.5H-1.5L1.5 3.5H4.5L7.5 6.5ZM-1.5 6.5V3C-1.5 0.680404 0.380404 -1.2 2.7 -1.2L3 1.2C2.17157 1.2 1.5 2.00589 1.5 3V3.5L-1.5 6.5ZM7.5 -1.2V6.5L4.5 3.5V1.2L7.5 -1.2Z",
    fill: "black",
    mask: "url(#path-1-inside-1_8200_130128)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0H17C18.6569 0 20 1.34315 20 3V5H6V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 -1.5H17C19.4853 -1.5 21.5 0.514719 21.5 3H18.5C18.5 2.17157 17.8284 1.5 17 1.5H6V-1.5ZM21.5 6.5H6V3.5H18.5L21.5 6.5ZM6 5V0V5ZM17 -1.5C19.4853 -1.5 21.5 0.514719 21.5 3V6.5L18.5 3.5V3C18.5 2.17157 17.8284 1.5 17 1.5V-1.5Z",
    fill: "black",
    mask: "url(#path-3-inside-2_8200_130128)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5H6V10H0V5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 10V11.5H7.5V10H6ZM0 10H-1.5V11.5H0V10ZM4.5 5V10H7.5V5H4.5ZM6 8.5H0V11.5H6V8.5ZM1.5 10V5H-1.5V10H1.5Z",
    fill: "black",
    mask: "url(#path-5-inside-3_8200_130128)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 5H20V10H6V5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 10V11.5H21.5V10H20ZM18.5 5V10H21.5V5H18.5ZM20 8.5H6V11.5H20V8.5Z",
    fill: "black",
    mask: "url(#path-7-inside-4_8200_130128)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10H6V15H0V10Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 15V16.5H7.5V15H6ZM0 15H-1.5V16.5H0V15ZM4.5 10V15H7.5V10H4.5ZM6 13.5H0V16.5H6V13.5ZM1.5 15V10H-1.5V15H1.5Z",
    fill: "black",
    mask: "url(#path-9-inside-5_8200_130128)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10H20V15H6V10Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 15V16.5H21.5V15H20ZM18.5 10V15H21.5V10H18.5ZM20 13.5H6V16.5H20V13.5Z",
    fill: "black",
    mask: "url(#path-11-inside-6_8200_130128)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15H6V20H3C1.34315 20 0 18.6569 0 17V15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 15H6H0ZM7.5 21.5H3C0.514719 21.5 -1.5 19.4853 -1.5 17H1.5C1.5 17.8284 2.17157 18.5 3 18.5H4.5L7.5 21.5ZM3 21.5C0.514719 21.5 -1.5 19.4853 -1.5 17V15H1.5V17C1.5 17.8284 2.17157 18.5 3 18.5V21.5ZM7.5 15V21.5L4.5 18.5V15H7.5Z",
    fill: "black",
    mask: "url(#path-13-inside-7_8200_130128)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_8200_130128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17C20 18.6569 18.6569 20 17 20H6V15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20H6ZM21.5 17C21.5 19.4853 19.4853 21.5 17 21.5H6V18.5H17C17.8284 18.5 18.5 17.8284 18.5 17H21.5ZM6 20V15V20ZM21.5 15V17C21.5 19.4853 19.4853 21.5 17 21.5V18.5C17.8284 18.5 18.5 17.8284 18.5 17V15H21.5Z",
    fill: "black",
    mask: "url(#path-15-inside-8_8200_130128)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8200_130128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.813c663c21d668eed5764ca55d271992.svg";
export { ForwardRef as ReactComponent };